module.exports = __webpack_public_path__ + "static/img/introduction-planet-barometer-hero-lowres.9ca4ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-planet-barometer-hero-lowres.jpg
// module id = jmYz
// module chunks = 0